document.addEventListener('DOMContentLoaded', function () {
  const tabList = document.querySelector('.ships__tab');
  const tabItems = tabList.querySelectorAll('li');

  // タブと ID のマッピング
  const tabMapping = {
    'le-ponant': 'ル ポナン',
    'sister-ships': 'シスターシップシリーズ',
    'explorer': 'エクスプローラーシリーズ',
    'charcot': 'ル コマンダン シャルコー',
    'gauguin': 'ル ポール ゴーギャン',
  };

  // 逆引き用のマッピング
  const reverseMapping = Object.entries(tabMapping).reduce(
    (acc, [key, value]) => {
      acc[value] = key;
      return acc;
    },
    {}
  );

  // URLからタブパラメータを取得して初期表示を設定
  const urlParams = new URLSearchParams(window.location.search);
  const activeTab = urlParams.get('tab');

  if (activeTab && tabMapping[activeTab]) {
    tabItems.forEach((item) => {
      if (item.textContent.trim() === tabMapping[activeTab]) {
        setActiveTab(item);
      }
    });
  }

  // タブクリックイベントの処理
  tabItems.forEach((item) => {
    item.addEventListener('click', () => {
      setActiveTab(item);
      const tabId = reverseMapping[item.textContent.trim()];
      updateURL(tabId);
    });
  });

  // アクティブタブの設定
  function setActiveTab(activeItem) {
    tabItems.forEach((item) => item.classList.remove('is-active'));
    activeItem.classList.add('is-active');
  }

  // URLパラメータの更新
  function updateURL(tabId) {
    const url = new URL(window.location);
    url.searchParams.set('tab', tabId);
    window.history.pushState({}, '', url);
  }
});
